export default __webpack_public_path__ + "static/company-website-1-412964d6f84036acf20154244d952b5c.png";